// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#project {
    font-size: 1.2rem;
    text-align: center;
}

.project-segment {
    display: flex;
    flex-direction: column;
    gap:0.5rem;
    overflow-y: auto;
    font-size: 1.2rem;
}

.add-icon {
    font-size: 2rem;
    cursor:pointer;
    transition: color 0.5s;
}
.add-icon:hover {
    color: var(--primary);
}

.project-input {
    width: 90%;
    outline: none;
    font-size: 1.2rem;
    height: 1.5rem;
    padding-left:5%;
    background-color: var(--select);
    border: none;
    color:var(--text);
    border-radius: 2rem;
    transition: border 0.5s;
}

.project-input:focus {
    border: 1px solid var(--secondary);
}`, "",{"version":3,"sources":["webpack://./src/styles/projects.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":["#project {\r\n    font-size: 1.2rem;\r\n    text-align: center;\r\n}\r\n\r\n.project-segment {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap:0.5rem;\r\n    overflow-y: auto;\r\n    font-size: 1.2rem;\r\n}\r\n\r\n.add-icon {\r\n    font-size: 2rem;\r\n    cursor:pointer;\r\n    transition: color 0.5s;\r\n}\r\n.add-icon:hover {\r\n    color: var(--primary);\r\n}\r\n\r\n.project-input {\r\n    width: 90%;\r\n    outline: none;\r\n    font-size: 1.2rem;\r\n    height: 1.5rem;\r\n    padding-left:5%;\r\n    background-color: var(--select);\r\n    border: none;\r\n    color:var(--text);\r\n    border-radius: 2rem;\r\n    transition: border 0.5s;\r\n}\r\n\r\n.project-input:focus {\r\n    border: 1px solid var(--secondary);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
